module.exports = {
	"endpoints": {
		"hostRunTime": "{{host-run-time || ''}}"
	},
	"httpSettings": {
		"timeout": 15000,
		"reloadQueryParamName": "goto",
		"reloadURL": "/index.html",
		"serviceBaseURLs": {
			"bc": "{{endpoints.hostRunTime}}/bc/service/edge/",
			"cc": "{{endpoints.hostRunTime}}/cc/service/edge/",
			"pc": "{{endpoints.hostRunTime}}/pc/service/edge/",
			"cm": "{{endpoints.hostRunTime}}/ab/service/edge/"
		}
	},
	"userSettings": {
		"sessionConfig": {
			"inactivityIntervalMins": 30,
			"logoutConfirmationIntervalMins": 1
		},
		"defaultLocaleDetails": {
			"countryCode": "US",
			"mapCenter": {
				"lat": 37.923933,
				"lon": -122.5203
			}
		}
	},
	"appSettings": {
		"fnolConfig": {
			"firstState": "policySelect",
			"multiplePolicies": true
		},
		"statePathConfig": {
			"fnol": "enrolled",
			"claims": "enrolled",
			"enrollment": "root",
			"serviceRequests": "enrolled",
			"faq": "enrolled"
		},
		"maxFileUploadSize": 50000000
	},
	"auth": {
		"auth0": {
			"clientId": "",
			"url": "",
			"requiresRedirectUrl": true,
			"redirectPath": "",
			"audience": "EdgeBackend",
			"endpoints": {
				"authorize": "/authorize",
				"userinfo": "/userinfo",
				"logout": "/v2/logout"
			},
			"scope": "openid profile",
			"logoutMode": "no-cors",
			"validate": "state",
			"silentLoginParam": "prompt=none",
			"usernameProperty": "name"
		},
		"uaa": {
			"url": "",
			"endpoints": {
				"authorize": "/oauth/authorize",
				"userinfo": "/userinfo",
				"logout": "/logout.do"
			},
			"logoutMode": "cors",
			"validate": "nonce",
			"usernameProperty": "user_name"
		}
	}
}